import axios from "axios";

export function deleteTemplate(payload) {
  return new Promise((resolve, reject) => {
    axios.delete(`/serialnumber/api/v1/product-ui-template/${payload.id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
